// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminRolesManagement-space1-O9TJq {
	margin-bottom: 6px !important;
}

.AdminRolesManagement-space2-P2Qcg {
	margin-bottom: 12px !important;
}

.AdminRolesManagement-space3-eRzeZ {
	margin-bottom: 18px !important;
}

.AdminRolesManagement-space4-ErRNl {
	margin-bottom: 24px !important;
}

.AdminRolesManagement-space5-XWO2D {
	margin-bottom: 30px !important;
}

.AdminRolesManagement-space6-C8CYl {
	margin-bottom: 36px !important;
}

.AdminRolesManagement-space7-Rrk2n {
	margin-bottom: 42px !important;
}

.AdminRolesManagement-space8-Hr0sW {
	margin-bottom: 48px !important;
}

.AdminRolesManagement-spaceTop1-_JfKq {
	margin-top: 6px !important;
}

.AdminRolesManagement-spaceTop2-z9v7y {
	margin-top: 12px !important;
}

.AdminRolesManagement-spaceTop3-MIgBU {
	margin-top: 18px !important;
}

.AdminRolesManagement-spaceTop4-fbfO3 {
	margin-top: 24px !important;
}

.AdminRolesManagement-spaceTop5-rMfhP {
	margin-top: 30px !important;
}

.AdminRolesManagement-spaceTop6-zbQBO {
	margin-top: 36px !important;
}

.AdminRolesManagement-spaceTop7-VCscF {
	margin-top: 42px !important;
}

.AdminRolesManagement-spaceTop8-VcFKA {
	margin-top: 48px !important;
}

.AdminRolesManagement-noMargin-fNpfs {
	margin: 0px !important;
}

.AdminRolesManagement-padding1-TGjR7 {
	padding-bottom: 6px !important;
}

.AdminRolesManagement-padding2-tQ0nK {
	padding-bottom: 12px !important;
}

.AdminRolesManagement-padding3-zLm4j {
	padding-bottom: 18px !important;
}

.AdminRolesManagement-padding4-gDBxm {
	padding-bottom: 24px !important;
}

.AdminRolesManagement-padding5-eVyxU {
	padding-bottom: 30px !important;
}

.AdminRolesManagement-padding6-qc8bG {
	padding-bottom: 36px !important;
}

.AdminRolesManagement-padding7-HqDR4 {
	padding-bottom: 42px !important;
}

.AdminRolesManagement-paddingTop1-udwII {
	padding-top: 6px !important;
}

.AdminRolesManagement-paddingTop2-uJkni {
	padding-top: 12px !important;
}

.AdminRolesManagement-paddingTop3-Xbjwo {
	padding-top: 18px !important;
}

.AdminRolesManagement-paddingTop4-YjfOk {
	padding-top: 24px !important;
}

.AdminRolesManagement-paddingTop5-byXqe {
	padding-top: 30px !important;
}

.AdminRolesManagement-paddingTop6-Nd7b5 {
	padding-top: 36px !important;
}

.AdminRolesManagement-paddingTop7-oDHCY {
	padding-top: 42px !important;
}

.AdminRolesManagement-noPadding-fm1Jf {
	padding: 0px !important;
}

.AdminRolesManagement-spaceMarginBottom0-bJVks {
	margin-bottom: 0;
}

.AdminRolesManagement-textBold-Umx0I {
	font-weight: 500 !important;
}

.AdminRolesManagement-textBolder-ESMvx {
	font-weight: 700 !important;
}

.AdminRolesManagement-textNormal-J1N3e {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminRolesManagement-textDarkBlue-v8vTl {
	color: rgb(20, 39, 94) !important;
}

.AdminRolesManagement-textLightBlue-euUBt {
	color: rgb(57, 87, 106) !important;
}

.AdminRolesManagement-textLightSandleGreen-IbNk5 {
	color: rgb(76, 86, 41) !important;
}

.AdminRolesManagement-textLightBrown-KLwc0 {
	color: rgb(115, 79, 33) !important;
}

.AdminRolesManagement-textMediumMaroon-c_1Z4 {
	color: rgb(87, 37, 51) !important;
}

.AdminRolesManagement-textBrown-fi_bA {
	color: rgb(160, 47, 24) !important;
}

.AdminRolesManagement-textMaroon-pGHKG {
	color: rgb(155, 49, 67) !important;
}

.AdminRolesManagement-textDarkBrown-vtxys {
	color: rgb(83, 18, 16) !important;
}

.AdminRolesManagement-textMediumBrown-tmfjE {
	color: rgb(142, 28, 10) !important;
}

.AdminRolesManagement-textSkyBlue-FrDcT {
	color: rgb(37, 117, 141) !important;
}

.AdminRolesManagement-textGray-NtjXk {
	color: rgb(77, 65, 51) !important;
}

.AdminRolesManagement-errorMessage-YHjVk {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminRolesManagement-userText-b6TCD {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminRolesManagement-panelHeader-tXQAr {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminRolesManagement-exportSection-TMIKw {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminRolesManagement-exportSectionGridSub-eddaW {
	grid-template-columns: 50% 49% !important;
}

.AdminRolesManagement-exportText-cQMzV {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminRolesManagement-exportLinkImg-_cdOn {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminRolesManagement-exportImg-FZOiE {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminRolesManagement-linkBtn-fSKTj {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminRolesManagement-table-LW7tF {
	display: table;
}

.AdminRolesManagement-tableRow-pxWA_ {
	display: table-row;
}

.AdminRolesManagement-tableCell-QEeHK {
	display: table-cell;
	float: none;
}

.AdminRolesManagement-formGroup-NiK5Q {
	margin-bottom: 6px;
}

.AdminRolesManagement-marginTop0-e5R9L {
	margin-top: 0;
}

.AdminRolesManagement-marginBottom20-Vm_JU {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminRolesManagement-bannerImageBg-IS7E_ {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminRolesManagement-bannerDelete-FhypL {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminRolesManagement-exportLink-NW5fI {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminRolesManagement-seachContent-rODHU {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminRolesManagement-marginBottom9-UbEiS {
	margin-bottom: 9px;
}

.AdminRolesManagement-spaceTop52-QANm6 {
	margin-top: 52px;
}

.AdminRolesManagement-profileViewInner-zmp1E {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminRolesManagement-profileViewMain-wTFCj {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminRolesManagement-profileViewlabel-biu0m {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminRolesManagement-profileViewMainContent-VGChD {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminRolesManagement-reviewsFormStar-REULK {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminRolesManagement-reviewsFormStar-REULK svg {
	cursor: pointer;
}

.AdminRolesManagement-addLanguageText-N0knB {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminRolesManagement-exportSection-TMIKw {
		grid-template-columns: 100%;
	}

	.AdminRolesManagement-spaceTop52-QANm6 {
		margin-top: 18px;
	}

	.AdminRolesManagement-exportText-cQMzV {
		float: none;
		margin-top: 12px;
	}

	.AdminRolesManagement-exportSectionGridSub-eddaW {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminRolesManagement-profileViewlabel-biu0m {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminRolesManagement-profileViewMainContent-VGChD {
		width: 100%;
		text-align: center;
	}

	.AdminRolesManagement-panelHeader-tXQAr {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminRolesManagement-space1-O9TJq`,
	"space2": `AdminRolesManagement-space2-P2Qcg`,
	"space3": `AdminRolesManagement-space3-eRzeZ`,
	"space4": `AdminRolesManagement-space4-ErRNl`,
	"space5": `AdminRolesManagement-space5-XWO2D`,
	"space6": `AdminRolesManagement-space6-C8CYl`,
	"space7": `AdminRolesManagement-space7-Rrk2n`,
	"space8": `AdminRolesManagement-space8-Hr0sW`,
	"spaceTop1": `AdminRolesManagement-spaceTop1-_JfKq`,
	"spaceTop2": `AdminRolesManagement-spaceTop2-z9v7y`,
	"spaceTop3": `AdminRolesManagement-spaceTop3-MIgBU`,
	"spaceTop4": `AdminRolesManagement-spaceTop4-fbfO3`,
	"spaceTop5": `AdminRolesManagement-spaceTop5-rMfhP`,
	"spaceTop6": `AdminRolesManagement-spaceTop6-zbQBO`,
	"spaceTop7": `AdminRolesManagement-spaceTop7-VCscF`,
	"spaceTop8": `AdminRolesManagement-spaceTop8-VcFKA`,
	"noMargin": `AdminRolesManagement-noMargin-fNpfs`,
	"padding1": `AdminRolesManagement-padding1-TGjR7`,
	"padding2": `AdminRolesManagement-padding2-tQ0nK`,
	"padding3": `AdminRolesManagement-padding3-zLm4j`,
	"padding4": `AdminRolesManagement-padding4-gDBxm`,
	"padding5": `AdminRolesManagement-padding5-eVyxU`,
	"padding6": `AdminRolesManagement-padding6-qc8bG`,
	"padding7": `AdminRolesManagement-padding7-HqDR4`,
	"paddingTop1": `AdminRolesManagement-paddingTop1-udwII`,
	"paddingTop2": `AdminRolesManagement-paddingTop2-uJkni`,
	"paddingTop3": `AdminRolesManagement-paddingTop3-Xbjwo`,
	"paddingTop4": `AdminRolesManagement-paddingTop4-YjfOk`,
	"paddingTop5": `AdminRolesManagement-paddingTop5-byXqe`,
	"paddingTop6": `AdminRolesManagement-paddingTop6-Nd7b5`,
	"paddingTop7": `AdminRolesManagement-paddingTop7-oDHCY`,
	"noPadding": `AdminRolesManagement-noPadding-fm1Jf`,
	"spaceMarginBottom0": `AdminRolesManagement-spaceMarginBottom0-bJVks`,
	"textBold": `AdminRolesManagement-textBold-Umx0I`,
	"textBolder": `AdminRolesManagement-textBolder-ESMvx`,
	"textNormal": `AdminRolesManagement-textNormal-J1N3e`,
	"textDarkBlue": `AdminRolesManagement-textDarkBlue-v8vTl`,
	"textLightBlue": `AdminRolesManagement-textLightBlue-euUBt`,
	"textLightSandleGreen": `AdminRolesManagement-textLightSandleGreen-IbNk5`,
	"textLightBrown": `AdminRolesManagement-textLightBrown-KLwc0`,
	"textMediumMaroon": `AdminRolesManagement-textMediumMaroon-c_1Z4`,
	"textBrown": `AdminRolesManagement-textBrown-fi_bA`,
	"textMaroon": `AdminRolesManagement-textMaroon-pGHKG`,
	"textDarkBrown": `AdminRolesManagement-textDarkBrown-vtxys`,
	"textMediumBrown": `AdminRolesManagement-textMediumBrown-tmfjE`,
	"textSkyBlue": `AdminRolesManagement-textSkyBlue-FrDcT`,
	"textGray": `AdminRolesManagement-textGray-NtjXk`,
	"errorMessage": `AdminRolesManagement-errorMessage-YHjVk`,
	"userText": `AdminRolesManagement-userText-b6TCD`,
	"panelHeader": `AdminRolesManagement-panelHeader-tXQAr`,
	"exportSection": `AdminRolesManagement-exportSection-TMIKw`,
	"exportSectionGridSub": `AdminRolesManagement-exportSectionGridSub-eddaW`,
	"exportText": `AdminRolesManagement-exportText-cQMzV`,
	"exportLinkImg": `AdminRolesManagement-exportLinkImg-_cdOn`,
	"exportImg": `AdminRolesManagement-exportImg-FZOiE`,
	"linkBtn": `AdminRolesManagement-linkBtn-fSKTj`,
	"table": `AdminRolesManagement-table-LW7tF`,
	"tableRow": `AdminRolesManagement-tableRow-pxWA_`,
	"tableCell": `AdminRolesManagement-tableCell-QEeHK`,
	"formGroup": `AdminRolesManagement-formGroup-NiK5Q`,
	"marginTop0": `AdminRolesManagement-marginTop0-e5R9L`,
	"marginBottom20": `AdminRolesManagement-marginBottom20-Vm_JU`,
	"bannerImageBg": `AdminRolesManagement-bannerImageBg-IS7E_`,
	"bannerDelete": `AdminRolesManagement-bannerDelete-FhypL`,
	"exportLink": `AdminRolesManagement-exportLink-NW5fI`,
	"seachContent": `AdminRolesManagement-seachContent-rODHU`,
	"marginBottom9": `AdminRolesManagement-marginBottom9-UbEiS`,
	"spaceTop52": `AdminRolesManagement-spaceTop52-QANm6`,
	"profileViewInner": `AdminRolesManagement-profileViewInner-zmp1E`,
	"profileViewMain": `AdminRolesManagement-profileViewMain-wTFCj`,
	"profileViewlabel": `AdminRolesManagement-profileViewlabel-biu0m`,
	"profileViewMainContent": `AdminRolesManagement-profileViewMainContent-VGChD`,
	"reviewsFormStar": `AdminRolesManagement-reviewsFormStar-REULK`,
	"addLanguageText": `AdminRolesManagement-addLanguageText-N0knB`
};
module.exports = ___CSS_LOADER_EXPORT___;
